var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeftArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33227 13.7802C6.46861 13.6395 6.54521 13.4486 6.54521 13.2496C6.54521 13.0505 6.46861 12.8597 6.33227 12.7189L2.48278 8.74605L15.2727 8.74605C15.4656 8.74605 15.6506 8.66698 15.787 8.52621C15.9234 8.38545 16 8.19454 16 7.99547C16 7.7964 15.9234 7.60549 15.787 7.46472C15.6506 7.32396 15.4656 7.24488 15.2727 7.24488L2.48278 7.24488L6.33227 3.27203C6.46475 3.13047 6.53806 2.94087 6.5364 2.74406C6.53474 2.54726 6.45825 2.35901 6.32341 2.21984C6.18857 2.08068 6.00616 2.00174 5.81546 2.00003C5.62477 1.99832 5.44106 2.07397 5.3039 2.2107L0.212937 7.4648C0.0765932 7.60556 -2.5337e-07 7.79644 -2.6207e-07 7.99547C-2.7077e-07 8.1945 0.0765931 8.38538 0.212937 8.52613L5.3039 13.7802C5.44028 13.921 5.62523 14 5.81808 14C6.01093 14 6.19588 13.921 6.33227 13.7802Z",
    fill: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeftArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/leftArrow.b27f4db27fb67b87d38c7d63005dee45.svg";